import { add, prop } from 'ramda';
import { PurchasedItem } from '../../../data/types/trade-item/purchased-item';

export function FilledCargoBays(cargo: PurchasedItem[]): number {
  return cargo.map(prop('quantity')).reduce(add, 0);
}
